<template>
  <div v-if="loadComponent">
    <v-form>
      <v-container>
        <!-- <h1>Pag-Ibig</h1> -->
        <v-row>
          <v-col cols="12" xs="12" sm="6" md="4" class="pb-0 mb-0">
            <v-text-field
              label="Code"
              :class="classPadding"
              v-model="group.approverGroupCode"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="8" class="pb-0 mb-0">
            <v-text-field
              label="Description"
              :class="classPadding"
              v-model="group.approverGroupDesc"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4" class="pb-0 mb-0">
            <v-text-field
              label="Remarks"
              :class="classPadding"
              v-model="group.remarks"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
            <v-btn
              color="success"
              :loading="isSaving"
              :class="classPadding"
              @click.stop="save"
              v-if="userAccess.add >= 1"
              >Save</v-btn
            >
          </v-col>
        </v-row>
      </v-container>
    </v-form>

    <v-container>
      <list :key="componentKey">
        <template slot="actions" slot-scope="{ item }">
          <v-btn @click.stop="edit(item)" text icon v-if="userAccess.edit >= 1">
            <v-icon color="primary">mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            @click.stop="deleteItem(item)"
            text
            icon
            v-if="userAccess.delete >= 1"
          >
            <v-icon color="error">mdi-delete</v-icon>
          </v-btn>
        </template>
      </list>
    </v-container>
    <v-dialog v-model="show" width="700" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">Edit</span>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
              <v-text-field
                label="Code"
                :class="classPadding"
                v-model="editGroup.approverGroupCode"
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
              <v-text-field
                label="Description"
                :class="classPadding"
                v-model="editGroup.approverGroupDesc"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="6" class="pb-0 mb-0">
              <v-text-field
                label="Remarks"
                :class="classPadding"
                v-model="editGroup.remarks"
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- <v-row>
          <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
            <v-btn color="success" :loading="isSaving" :class="classPadding" @click.stop="save">Save</v-btn>
          </v-col>
          </v-row>-->
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="error" @click.stop="show = false">Close</v-btn>
          <v-btn
            text
            color="success"
            @click.stop="update"
            :loading="isUpdating"
            v-if="userAccess.update >= 1"
            >Update</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import List from "./List";
import eventBus from "../../../../../events/eventBus";
import userAccessMixin from "../../../../../mixins/userAccessMixin";
const API_ENDPOINT = "/api/approverGroup";
export default {
  metaInfo: {
    // title: "Pag-Ibig",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
  },
  mixins: [userAccessMixin],
  components: {
    List
  },
  data: () => ({
    classPadding: "my-0 py-0",
    isSaving: false,
    group: {},
    componentKey: 0,
    show: false,
    editGroup: {},
    isUpdating: false
  }),
  methods: {
    save() {
      this.isSaving = true;

      this.$axios
        .post(`${API_ENDPOINT}`, this.group)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
          eventBus.$emit("PME_APPROVER_GROUP");
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
    edit(item) {
      this.show = true;
      this.editGroup = Object.assign({}, item);
      //   this.$router.push(`/pagibig-setup/edit/${item.approverGroupCode}`);
    },
    deleteItem(item) {
      this.$confirm(this.$deleteConfirm, {
        color: "error",
        title: "Delete"
      }).then(res => {
        if (res) {
          this.$axios
            .delete(`${API_ENDPOINT}/${item.approverGroupCode}`)
            .then(({ data }) => {
              this.$toast.success(data.message);
              this.reset();
              eventBus.$emit("PME_APPROVER_GROUP");
            })
            .catch(({ response }) => {
              this.$toast.error(response.data.message);
            });
        }
      });
    },
    reset() {
      this.group = {};
      this.forceRerender();
    },
    forceRerender() {
      this.componentKey += 1;
    },
    update() {
      this.isUpdating = true;

      this.$axios
        .put(`${API_ENDPOINT}`, this.editGroup)
        .then(({ data }) => {
          this.$toast.success(data.message);
          //   this.$router.push("/");
          this.show = false;
          this.forceRerender();
          eventBus.$emit("PME_APPROVER_GROUP");
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isUpdating = false;
        });
    }
  },
  watch: {
    // $route(val) {
    //   if (val.name === "pme-approvers") {
    //     this.forceRerender();
    //   }
    // }
  },
  created() {
    this.getUserAccessRights("PMEApprovS");
  }
};
</script>